// import React, { Component } from 'react';
// import {Dropdown} from 'primereact/dropdown';
// import {InputText} from 'primereact/inputtext';
// import {Button} from 'primereact/button';
// import {Editor} from 'primereact/editor';
// import {Toolbar} from 'primereact/toolbar';
// import { Link } from "react-router-dom";
// const PROCESS=[];
// const STAGE = [];
// const ACTION = [];

// export class EmailTemplateMaster extends Component {
//     state = {
//         templateName:"",
//         process:"",
//         stage:"",
//         action:""
//     }

 
//     render() { 
        
//         return (
//             <div className="p-grid">
//                 <div className="p-col-12">
//                     <div className="card card-w-title">
//                         <h1>E-mail Template</h1>     
//                         <Toolbar>
//                             <div className="p-toolbar-group-left">
//                                 <Button  icon="pi pi-save" className="p-button-success"  style={{marginRight:'.25em'}} />
//                                 <Button   icon="pi pi-trash" className="p-button-danger"  style={{marginRight:'.25em'}} />
//                                 <Link to="/ "><Button icon="pi pi-arrow-left" className="p-button-secondary" /></Link>
//                             </div>
                       
//                         </Toolbar>  
                    

//                         <div className="p-grid mt3">
                            
//                                 <div className="p-col-12 p-md-6 p-lg-3">
//                                     <label className="label">Template Name</label>
//                                     <div className="mt1"> 
//                                         <InputText className="p-col-12" name="templateName"  placeholder="Template Name"/>
//                                     </div>                                
//                                 </div>

//                                 <div className="p-col-12 p-md-6 p-lg-3">
//                                     <label className="label">Process</label>
//                                 <div className="mt1">
//                                     <Dropdown className="p-col-12" options={PROCESS} name="process" value={this.state.process} onChange={event => this.setState({process: event.value})} autoWidth={false} placeholder="Processes" />
//                                 </div>   
//                                 </div> 

//                                 <div className="p-col-12 p-md-6 p-lg-3">
//                                     <label className="label">Stage</label>
//                                 <div className="mt1">
//                                     <Dropdown className="p-col-12" options={STAGE} name="stage" value={this.state.stage} onChange={event => this.setState({stage: event.value})} autoWidth={false}  placeholder="Stages"/>
//                                 </div>   
//                                 </div> 

//                                 <div className="p-col-12 p-md-6 p-lg-3">
//                                     <label className="label">Action</label>
//                                 <div className="mt1">
//                                     <Dropdown className="p-col-12" options={ACTION} name="action" value={this.state.action} onChange={event => this.setState({action: event.value})} autoWidth={false} />
//                                 </div>   
//                                 </div> 

//                             <div className="p-col-12">
//                                     <h1>Editor</h1>
//                                     <Editor style={{height:'320px'}} />
//                                 </div>
                            
                                                           

//                         </div>
                      
//                 </div>
//             </div>
//             </div>
                
//         );
//     }
// }


// ----------------------


import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Toast} from 'primereact/toast';
import {MultiSelect} from 'primereact/multiselect';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID} from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';


import {Button} from 'primereact/button';
import {Editor} from 'primereact/editor';
import {Toolbar} from 'primereact/toolbar';
import { Link } from "react-router-dom";

const PROCESS=[];
const STAGE = [];
const ACTION = [];
const PROCESS_VARIABLES = [{Key: 'EmployeeName', Label: 'Employee Name'}, {Key: 'ManagerName', Label: 'Manager Name'}, {Key: 'ProcessName', Label: 'Process Name'}, {Key: 'StageName', Label: 'Stage Name'}, {Key: 'ActionName', Label: 'Action Name'}];

class EmailTemplateMaster extends Component {
    state = {
        roles : [],
        type: 'add',
        Id:null,
        UserId:null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [], 
        approvalRoleId: null,       
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch : false,
         templateName:"",
        process:"",
        stage:"",
        action:""
    }

    componentDidMount(){
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GeUsers?id='+id);   
        this.props.getMasterKeywordList('Role'); 
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('ApprovalRole'); 
        let type = this.props.match.params.type;

        axios.get('/master/api/DropDownValues/FRole')
                .then(response =>{
                    if(response.status === 200){
                        let data = []
                        if(response.data && response.data.length > 0){
                            data = response.data.map(list => {
                                let value= list.id;
                                let id = list.id;
                                let text = list.text
                                return {label : text, value:value.toString(), id:id};
                            })
                        }
                        this.setState({functionalRoleOptions: data})
                    }}
                )
                .catch(err => {
                    this.growl.show({severity: 'error', summary: null, detail: 'Functional Roles Api Failed'});
                })   

        if(type !== 'add'){
            this.timer();
        }
    }

    timer = () =>{
        this.intervalID = setInterval(()=> {
            this.fetchSingleProcess();
        },2000)
    }    
    componentWillUnmount(){
        if(this.props.tableLists.usersList!==undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];
        if(this.props.tableLists.usersList!==undefined) {
            storageItems = this.props.tableLists.users;
            clearInterval(this.intervalID);
        }
        if(storageItems){
            let filterData = storageItems;
            if(filterData){
                let roles ='';
                let functionalRoles ='';
                let approvalroles ='';
                if(filterData.roleAssigned!=null){
                    roles = filterData.roleAssigned.split(",") 
                }
                if(filterData.functionalRole!=null){
                    functionalRoles = filterData.functionalRole.split(",") 
                }
                if(filterData.approvalrole!=null){
                    approvalroles = filterData.approvalrole.split(",") 
                }
                var data = {
                    type:type,
                    Id:filterData.id,
                    UserId: filterData.userId,
                    EmployeeId: filterData.employeeId,            
                    RoleId: roles,
                    approvalRoleId:approvalroles,
                    UserId1: filterData.userid1,
                    FirstName: filterData.firstName,
                    functionalRoleId: functionalRoles,
                    MiddleName: filterData.middleName,
                    LastName:filterData.lastName,
                    EmailId: filterData.emailId,
                    Password: filterData.password,
                    MobileNumber: filterData.mobileNumber,
                    Activedirectory: filterData.activedirectory,
                    Adloginid: filterData.adloginid,
                    Disablelogin: filterData.disablelogin,
                    IsActive: filterData.isActive,
                    CreatedBy : filterData.createdby,
                    CreatedDate : filterData.createddate,
                }
                this.setState(data);
                
            }
        }

    }


    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    add = () => {

        if(this.state.EmployeeId === null){
            this.growl.show({severity: 'error', summary: null, detail: 'Employee is required'});
            return;
        }else if(this.state.RoleId === null || this.state.RoleId === ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Role is required'});
            return;
        }
        
        else if(this.state.UserId1 === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'UserName is required'});
            return;
        }else if(this.state.FirstName === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'FirstName is required'});
            return;
        }else if(this.state.LastName === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'LastName is required'});
            return;
        }else if(this.state.EmailId === "" || this.state.EmailId === null){
            this.growl.show({severity: 'error', summary: null, detail: 'EmailId is required'});
            return;
        }else if(this.state.Password === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'Password is required'});
            return;
        }else if(this.state.MobileNumber === "" || this.state.MobileNumber === null ){
            this.growl.show({severity: 'error', summary: null, detail: 'MobileNumber is required'});
            return;
        }else if(this.state.approvalRoleId === "" || this.state.approvalRoleId === null ){
        this.growl.show({severity: 'error', summary: null, detail: 'Approval Roleid is required'});
        return;
        }else if(this.state.functionalRoleId === "" || this.state.functionalRoleId === null ){
            this.growl.show({severity: 'error', summary: null, detail: 'functional Roleid is required'});
            return;
        }
        var data = {
            EmployeeId: this.state.EmployeeId,            
            RoleId: null,
            UserId1: this.state.UserId1,
            FirstName: this.state.FirstName,
            FunctionalRole: this.state.functionalRoleId.join(),
            Approvalrole: this.state.approvalRoleId.join(),
            MiddleName: this.state.MiddleName,
            LastName: this.state.LastName,
            EmailId: this.state.EmailId,
            Password: this.state.Password,
            MobileNumber: this.state.MobileNumber,
            RoleAssigned: this.state.RoleId.join(),
            Activedirectory: this.state.Activedirectory,
            Adloginid: this.state.Adloginid,
            Disablelogin: this.state.Disablelogin,
            IsActive: this.state.IsActive,
            CompanyId : this.state.CompanyId,
            CreatedBy : this.state.createdBy,
            CreatedDate : this.state.createdDate,
        }
   
        
        if(this.state.type === 'edit'){
            data.UserId = this.state.UserId;
            data.Id = this.state.Id
        }

        this.props.processDynamicData('user',this.state.type,data,'GeUsers');

    }

    resetData = () => {
        var data = {
            UserId: null,
            EmployeeId: null,            
            RoleId: null,
            functionalRoleId: null,
            approvalRoleId: null,
            UserId1:'',
            FirstName: '',
            MiddleName: '',
            LastName:'',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type:'add'
        }
        this.setState(data);
    }
  
    render() {   
        if(this.props.success){
            REDIRECT_TO_URL('/users/',this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let roleOptions = [];
        if(this.props.Role && this.props.Role.length > 0 ){
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if(this.props.ApprovalRole && this.props.ApprovalRole.length > 0 ){
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/users/';
        if(this.props.userDetail && this.props.match.params.id!==undefined){
            if(this.props.userDetail.userId === this.props.match.params.id){
                redirectURL = "/dashboard";
            }
        }
        

       return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>E-mail Template</h1>     
                        <Toolbar>
                            <div className="p-toolbar-group-left">
                                <Button  icon="pi pi-save" className="p-button-success"  style={{marginRight:'.25em'}} />
                                <Button   icon="pi pi-trash" className="p-button-danger"  style={{marginRight:'.25em'}} />
                                <Link to="/ "><Button icon="pi pi-arrow-left" className="p-button-secondary" /></Link>
                            </div>
                       
                        </Toolbar>  
                    

                        <div className="p-grid mt3">
                            
                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <label className="label">Template Name</label>
                                    <div className="mt1"> 
                                        <InputText className="p-col-12" name="templateName"  placeholder="Template Name"/>
                                    </div>                                
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <label className="label">Process</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={PROCESS} name="process" value={this.state.process} onChange={event => this.setState({process: event.value})} autoWidth={false} placeholder="Processes" />
                                </div>   
                                </div> 

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <label className="label">Stage</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={STAGE} name="stage" value={this.state.stage} onChange={event => this.setState({stage: event.value})} autoWidth={false}  placeholder="Stages"/>
                                </div>   
                                </div> 

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <label className="label">Action</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={ACTION} name="action" value={this.state.action} onChange={event => this.setState({action: event.value})} autoWidth={false} />
                                </div>   
                                </div> 

                         
                    {/* ── Editor section split into two panes ── */}
                    <div className="p-col-12">
                    <h1>Editor</h1>
                    <div className="p-grid">

                    {/* LEFT PANE — Process Variables */}
                    <div className="p-col-12 p-md-3" style={{borderRight: '1px solid #dee2e6'}}>
                    <h4 style={{marginTop: 0}}>Process Variables</h4>
                    <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                        {PROCESS_VARIABLES.map((variable) => (
                            console.log(variable),
                        <li
                            key={variable.Key}
                            style={{
                            padding: '6px 8px',
                            marginBottom: '4px',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            fontSize: '13px',
                            background: '#f8f9fa',
                            border: '1px solid #e9ecef'
                            }}
                            onClick={() => this.insertVariable(variable.Key)}
                            title={variable.Label}
                        >
                            <span style={{fontFamily: 'monospace', color: '#495057'}}>{variable.Key}</span>
                            <br />
                            <span style={{color: '#868e96', fontSize: '11px'}}>{variable.Label}</span>
                        </li>
                        ))}
                    </ul>
                    </div>

                    {/* RIGHT PANE — Text Editor */}
                    <div className="p-col-12 p-md-9">
                    <Editor style={{height: '320px'}} />
                    </div>

                </div>
                </div>

            </div>
            </div>
        </div>
        </div>
                
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        Role : (state.keyword.Role!==undefined) ? state.keyword.Role : [],
        ApprovalRole : (state.keyword.ApprovalRole!==undefined) ? state.keyword.ApprovalRole : [],        
        tableLists : state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(EmailTemplateMaster);